import React from "react";

/**
 * Règles de mot de passe unifiées + indicateurs visuels temps réel.
 * Mêmes règles que côté backend : ≥ 8 caractères, ≥ 1 majuscule, ≥ 1 chiffre.
 */
export const PASSWORD_RULES = [
  { key: "length", label: "8 caractères minimum", test: (p) => (p || "").length >= 8 },
  { key: "upper", label: "1 majuscule (A-Z)", test: (p) => /[A-Z]/.test(p || "") },
  { key: "digit", label: "1 chiffre (0-9)", test: (p) => /\d/.test(p || "") },
];

export function isPasswordStrong(pwd) {
  return PASSWORD_RULES.every((rule) => rule.test(pwd));
}

/**
 * <PasswordStrengthChecklist password={pwd} testIdPrefix="first-pwd" />
 * Chaque item porte data-testid="{prefix}-hint-{key}" avec état "ok"/"pending".
 */
export function PasswordStrengthChecklist({ password, testIdPrefix = "pwd" }) {
  return (
    <ul
      data-testid={`${testIdPrefix}-hints`}
      className="mt-1 space-y-0.5 text-xs"
    >
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.key}
            data-testid={`${testIdPrefix}-hint-${rule.key}`}
            data-state={ok ? "ok" : "pending"}
            className={ok ? "text-emerald-300" : "text-slate-400"}
          >
            {ok ? "✓" : "•"} {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
